var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-loader",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{ref:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }